module.exports = __webpack_public_path__ + "img/chr_ts_90_22_2.f087b6c6.png";